import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _3DS2 } from '../../../actions/types'
import { updateOnEditId, updateApiToken, updateStoreId, updatePan, updateAmount, updateCurrency, updateExpDate, resetConfig } from '../../../actions/commonActions'

export class Configuration extends Component {
    render() {
        const { storeId, apiToken, pan, amount, currency, expdate } = this.props;

        return (
            <div className="config">
                <table style={{ marginBottom: '10px',width: '100%', paddingRight: '10px'}}>
                    <tr>
                        <td style={styles.title}>Store ID:</td>
                        <td style={styles.feild}><input style={{ width: '100%'}} type='text' onFocus={() => this.props.updateOnEditId({featureId: _3DS2, valueId: "storeId"})} value={storeId} onChange={text => this.props.updateStoreId({ featureId: _3DS2, storeId: text.target.value})}/></td>
                    </tr>
                    <tr>
                        <td style={styles.title}>API Token:</td>
                        <td style={styles.feild}><input type='text' onFocus={() => this.props.updateOnEditId({featureId: _3DS2, valueId: "apiToken"})} value={apiToken} onChange={text => this.props.updateApiToken({ featureId: _3DS2, apiToken: text.target.value})}/></td>
                    </tr>
                    <tr>
                        <td style={styles.title}>PAN:</td>
                        <td style={styles.feild}><input type='text' onFocus={() => this.props.updateOnEditId({featureId: _3DS2, valueId: "pan"})} value={pan} onChange={text => this.props.updatePan({ featureId: _3DS2, pan: text.target.value})}/></td>
                    </tr>
                    <tr>
                        <td style={styles.title}>Amount:</td>
                        <td style={styles.feild}><input type='text' onFocus={() => this.props.updateOnEditId({featureId: _3DS2, valueId: "amount"})} value={amount} onChange={text => this.props.updateAmount({ featureId: _3DS2, amount: text.target.value})}/></td>
                    </tr>
                    <tr>
                        <td style={styles.title}>Currency:<br />(ISO code)</td>
                        <td style={styles.feild}><input type='text' onFocus={() => this.props.updateOnEditId({featureId: _3DS2, valueId: "currency"})} value={currency} onChange={text => this.props.updateCurrency({ featureId: _3DS2, currency: text.target.value})}/></td>
                    </tr>
                    <tr>
                        <td style={styles.title}>Exp Date:</td>
                        <td style={styles.feild}><input type='text' onFocus={() => this.props.updateOnEditId({featureId: _3DS2, valueId: "expdate"})} value={expdate} onChange={text => this.props.updateExpDate({ featureId: _3DS2, expDate: text.target.value})}/></td>
                    </tr>
                </table>
                <div className="resetButton" style={{marginLeft: '40%', marginBottom: '0vh', marginTop: '1vh'}} onClick={() => this.props.resetConfig(_3DS2)}>RESET</div>
            </div>
        )
    }
}

const styles = {
    title: { 
        fontSize: '0.7rem',
        color: '#000', 
        textAlign: 'left', 
        paddingLeft: '1vw', 
        paddingTop: '0.4vw', 
        paddingBottom: '0.4vw',
        width: '80px',
    },
    feild: { 
        paddingTop: '0.7vh', 
        paddingBottom: '0.7vh',
        paddingRight: '0vw',
        paddingLeft: '0vw',
    },
}

const mapStateToProps = state => {
    const { storeId, apiToken, order_id, pan, amount, currency, expdate, notification_url, cardholder_name, cust_id, cavv } = state.threeDSTwo.main.config;
    return { storeId, apiToken, order_id, pan, amount, currency, expdate, notification_url, cardholder_name, cust_id, cavv };
}

export default connect(mapStateToProps, {updateOnEditId, updateApiToken, updateStoreId, updatePan, updateAmount, updateCurrency, updateExpDate, resetConfig})(Configuration)
